import { CommonModule } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { MenubarModule } from 'primeng/menubar';
import { RippleModule } from 'primeng/ripple';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, ButtonModule, MenubarModule, RippleModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  isMobileMenuOpen = false;
  isScrolled: boolean = false;
  isSticky = false;
  menuItems: any[] = [];
  activeItem: string = 'Home'; // Tracks the active menu item

  constructor(@Inject(PLATFORM_ID) private platformId: Object, protected router: Router) { }

  toggleMobileMenu() {
    this.isMobileMenuOpen = !this.isMobileMenuOpen;
  }

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;

    this.isSticky = scrollPosition > 0;
  }

  ngOnInit() {
    this.initializeMenu();
    this.onScroll();
  }
  
  initializeMenu(): void {
    // this.menuItems = [
    //   { label: 'Home', target: 'app-banner', command: () => this.scrollToSection('.app-banner') },
    //   { label: 'About', target: 'app-about-us', command: () => this.scrollToSection('.app-about-us') },
    //   { label: 'Services', target: 'app-services', command: () => this.scrollToSection('.app-services') },
    //   { label: 'Installation Questions', target: 'app-installation-questions', command: () => this.scrollToSection('.app-installation-questions') },
    //   { label: 'Plans & Pricing', target: 'app-plans-pricing', command: () => this.scrollToSection('.app-plans-pricing') },
    //   { label: 'FAQ', target: 'app-faq', command: () => this.scrollToSection('.app-faq') },
    // ];
    this.menuItems = [
      { label: 'Home', target: 'app-banner', command: () => this.scrollToSection('.app-banner') },
      { label: 'Plans & Pricing', target: 'app-plans-pricing', command: () => this.scrollToSection('.app-plans-pricing') },
      { label: 'Services', target: 'app-services', command: () => this.scrollToSection('.app-services') },
      { label: 'Installation Questions', target: 'app-installation-questions', command: () => this.scrollToSection('.app-installation-questions') },
      { label: 'About', target: 'app-about-us', command: () => this.scrollToSection('.app-about-us') },
      { label: 'FAQ', target: 'app-frequently', command: () => this.scrollToSection('.app-frequently') },
      { label: 'Contact', target: 'app-contact-info', command: () => this.scrollToSection('.app-contact-info') },
    ];
  }

  scrollToSection(target: string): void {
    console.debug("scroll to position", target);
      const element = document.querySelector(target);
      const offsetTop = window.innerWidth < 767 ? 68 : 100;
      if (element) {
        // Calculate the desired scroll position with some spacing
        const offset = offsetTop;  // The space you want from the top (you can adjust this value)
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const position = elementPosition - offset;  // Adjust position by offset
        
        // Scroll to the calculated position
        window.scrollTo({
          top: position,
          behavior: 'smooth'
        });
  
        this.updateActiveMenuItem(target);
    }
  }  

  @HostListener('window:scroll', [])
  onScroll(): void {
      const scrollPosition = 
        document.documentElement.scrollTop || document.body.scrollTop;

      this.isScrolled = scrollPosition > 100;
      this.updateActiveMenuItemByScroll(scrollPosition);
  }

  private updateActiveMenuItem(target: string): void {
    const item = this.menuItems.find((menu) => '.' + menu.target === target);
    if (item) {
      this.activeItem = item.label;
    }
  }

  private updateActiveMenuItemByScroll(scrollPosition: number): void {
    const offsets = this.menuItems
      .map((item) => {
        const element = document.querySelector('.' + item.target) as HTMLElement;
        if (element) {
          return { label: item.label, offsetTop: element.offsetTop };
        }
        return null;
      })
      .filter(Boolean);
  
    const offsetTop = window.innerWidth < 767 ? 80 : 110;
    const adjustedScrollPosition = scrollPosition + offsetTop; // Adjust based on header height
  
    for (let i = offsets.length - 1; i >= 0; i--) {
      if (adjustedScrollPosition >= offsets[i]!.offsetTop) {
        this.activeItem = offsets[i]!.label;
        break;
      }
    }
  }  

    // Redirect to login page
    login() {
      const url = this.getBillingUrl();
      console.log("Navigating to", url);
      window.open(url);
    }

    getBillingUrl() {
       let result = "https://billing.claddedglass.com";
       if (!environment.production)
       {
        result = "https://billing.dev.claddedglass.com";
       }
       return result;
    }
  
}
